import { Box } from "@vapor/react-material";
import { Bubbles } from "./Bubbles";
import { BusinessGrown } from "./BusinessGrown";
import { SustainablePlatform } from "./SustainablePlatform";

const AdvertisingChildren = () => (
    <Box>
        <SustainablePlatform />
        <BusinessGrown />
        <Bubbles />
    </Box>
);

export default AdvertisingChildren;
